import { render, staticRenderFns } from "./tmpIpfcToIpfc.vue?vue&type=template&id=276a57d8"
import script from "./tmpIpfcToIpfc.vue?vue&type=script&lang=js"
export * from "./tmpIpfcToIpfc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports